// lading statuses
export const STATUSES: string[] = [
    'Booked', "Unassigned", "Cancelled", 
    'En Route Shipper', 'Arrived Shipper', 'Loaded Shipper', 'Detained Shipper', 'Order FulFillment', 
    'En Route Consignee', 'Arrived Consignee', 'Detained Consignee', 'Unloading Consignee', 'Delivered Consignee',
    'Delay Mechanical', 'Delay Traffic', 'Delay Accident', 'Delay Weather', 'Delay Inspection', 'Delay Other',
    'Load Check', 'Load Completed', 'Load Incomplete', 'Load Temperature Check', 'Load Scale', 'Load Damage',
    'Arrived Customs', 'Detained Customs', 'Cleared Customs', 'Arrived Inspection', 'Cleared Inspection',
    'Arrived Terminal', 'Departed Terminal', 'Load Delayed', 'Border Delayed'
];

export const TRAILER_TYPES = {
    V: 'Van',
    R: 'Refrigerated Carrier (Reefer)',
    F: 'Flatbed',
    TWOF: 'Two 24 or 28 foot Flats',
    ANIM: 'Animal Carrier',
    ANYE: 'Any Equipment',
    AUTO: 'Auto carrier',
    B_TR: 'B-Train/Supertrain',
    BDMP: 'Belly Dump',
    BEAM: 'Beam',
    BELT: 'Conveyor Belt',
    BOAT: 'Boat Hauling Trailer',
    CH: 'Convertible Hopper',
    CONG: 'Conestoga',
    CONT: 'Container Trailer',
    CV: 'Curtain Van',
    DA: 'Drive Away',
    DD: 'Double Drop',
    DDE: 'Double Drop Extendable',
    DUMPT: 'Dump Trucks',
    ENDP: 'End Dump',
    FA: 'FlatBed - Air-Ride',
    FEXT: 'Stretch Trailers or Extendable',
    FINT: 'Flatbed Intermodal',
    FO: 'Flatbed Over-Dimension Loads',
    FSD: 'Flat or Step Deck',
    FSDV: 'Flatbed, Step Deck, or Van',
    FV: 'Van or Flatbed',
    FVR: 'Flatbed, Van, or Reefer',
    FVV: 'Flatbed, Vented Van, or Reefer',
    FWS: 'Flatbed With Sides',
    HOPP: 'Hopper Bottom',
    HS: 'Hot Shot',
    HTOW: 'Haul and Tow Unit',
    LAF: 'Landoll Flatbed',
    LB: 'Lowboy',
    LBO: 'Lowboy over-dimension load',
    LDOT: 'Load-Out are empty trailers you load and haul',
    LIVE: 'Live Bottom Trailer',
    MAXI: 'Maxi or Double Flat Traillers',
    MBHM: 'Mobile Home',
    PNEU: 'Pneumatic',
    PO: 'Power Only (tow-away)',
    RFV: 'Flatbed, Van, or Reefer',
    RGN: 'Removable Goose Neck & Multi-Axle Heavy Haulers',
    RGNE: 'RGN Extendable',
    RINT: 'Refrigerated Intermodal',
    ROLL: 'ROLL Top Conestoga',
    RPD: 'Refrigerated Carrier W/Plant Decking',
    RF: 'Van or Reefer',
    RVF: 'Flatbed, Van, or Reefer',
    SD: 'Step Deck',
    SDE: 'Step Deck Extendable',
    SDL: 'Step Deck w/Loading Ramps',
    SDO: 'Step Deck over-dimension load',
    SDRG: 'Step Deck or RemovableGooseneck',
    SPEC: 'Unspecified Specialized',
    HCV: 'High Cube Van',
    ST: 'Straight Truck',
    TANK: 'Tanker',
    V_OT: 'Open Top Van',
    VA: 'Van - Air-Ride',
    VB: 'Blanket Wrap Van',
    VCAR: 'Cargo Vans (1 Ton capacity)',
    VF: 'Flatbed or Van',
    VFR: 'Flatbed, Van, or Reefer',
    VINT: 'Van Intermodal',
    VIV: 'Vented Insulated Van',
    VIVR: 'Vented Insulated Van or Refrigerated',
    VLG: 'Van w/Liftgate',
    VM: 'Moving Van',
    VR: 'Van or Reefer',
    VRDD: 'Van, Reefer Double Drop',
    VRF: 'Flatbed, Van, or Reefer',
    VV: 'Vented Van',
    VVR: 'Vented Van or Refrigerated',
    WALK: 'Walking Floor Odometer'
}

export const NOTETYPES: string[] = ['Cost Note', 'Chargable Note', 'Cost Acutal Note'];

export const SERVICES: string[] = ['Service Program', 'Accessorial Service', 'Surcharge Service', 'Tradeshow Service',
    'Trailer Build Service', 'Suncor Service', 'Customs Service', 'Delivery Service', 'Pickup Service', 'Labourer Service'];

export const SERVICE_PROGRAM: string[] = [
    "",
    "FBI Warehouse Sales",
    "FBI Warehouse Sales US",
    "Freight Broker Sales",
    "Freight Broker Sales US",
    "Freight Solvers",
    "Freight Solvers Audit",
    "Freight Solvers US",
    "Trailer Build"
];

export const ACCESSORIAL_TYPE: string[] = [
    "",
    "Barge Service",
    "Beyond Charge",
    "Bulky Article",
    "Cartage",
    "Change In terms of Pay",
    "Container Lift Crane",
    "Correct BOL Charge",
    "Courier",
    "Crossdock",
    "DDP Charges",
    "Dangerous Goods",
    "Detention",
    "Disposal Fee",
    "Drayage",
    "Exclusive Use",
    "Expedite",
    "Export Shipping Charge",
    "Extraction",
    "Facility Fee",
    "Forklift",
    "Haz Mat",
    "Heated Service",
    "Inspection Fee",
    "Inward Charge",
    "Layover",
    "Linehaul Inbound",
    "Linehaul Outbound",
    "Linehaul",
    "Linked Expense",
    "Loading",
    "Maintenance",
    "Marking Tagging",
    "Materials",
    "Minimum Charge",
    "Off Line Miles",
    "Over The Road",
    "Pallet Allowance",
    "Redirect",
    "Refused",
    "Return To Shipper",
    "Reworking Freight",
    "Scale Ticket",
    "Scrap Yard Fees",
    "Segregation Charge",
    "Service Charge",
    "Single Shipment",
    "Site Inspection",
    "Skid Fee",
    "Skid Wrapping",
    "Sortation Charge",
    "Stair Crawler",
    "Stop Off",
    "Storage In Transit",
    "Supplies",
    "Tarping",
    "Team Service",
    "Tilt Load Lift Equipment",
    "Tolls",
    "Trailer Drop",
    "Trailer Repair",
    "Trailer Shunt",
    "Trailer Storage",
    "Truck Furnished Not Used",
    "Truck Overflow",
    "Unloading",
    "Waiting Overtime",
    "Waiting Time",
    "Weight Inspection Fee",
    "White Glove Service"
];

export const SURCHARGE_TYPE: string[] = [
    "",
    "Delivery Surcharge",
    "Carbon Surcharge",
    "Haz Mat Surcharge",
    "Fuel Surcharge LTL",
    "Fuel Surcharge TL",
    "Fuel Surcharge Flat",
    "Non Conveyable Surcharge",
    "Fuel Surcharge",
    "Pan Am Games",
    "Service Surcharge"
];

export const TRADESHOW_TYPE: string[] = [
    "",
    "Tradeshow Adminstration",
    "Tradeshow Delivery",
    "Tradeshow Pickup"
];

export const TRAILER_BUILD_TYPE: string[] = [
    "",
    "Build Cleaning",
    "Build Consulting",
    "Build Contruction",
    "Build Cover Storage",
    "Build Delivery",
    "Build Detention",
    "Build GPS",
    "Build License Plates",
    "Build Maintenance",
    "Build Material",
    "Build Missed Pickup",
    "Build Nets",
    "Build Permit",
    "Build Purchase",
    "Build Repair",
    "Build Shelf Covers",
    "Build Shunt",
    "Build Storage",
    "Build Truck Wash",
    "Build Waiting Time",
    "Build Wrap"
];

export const SUNCOR_TYPE: string[] = [
    "",
    "Suncor Certification",
    "Suncor Safety",
    "Suncor Unloading"
];

export const CUSTOMS_TYPE: string[] = [
    "",
    "Border Delay",
    "Border Security",
    "Border Crossing",
    "Bond Charge",
    "Bond with Re-Delivery",
    "Customs Detention",
    "Customs Devanning",
    "Customs Brokerage",
    "Customs Exam",
    "Duty"
];

export const DELIVERY_TYPE: string[] = [
    "",
    "Delivery After Hours",
    "Delivery Appointment",
    "Delivery Detention",
    "Delivery Rate",
    "Delivery Extra",
    "Delivery Inside",
    "Re-Delivery",
    "Delivery Residential",
    "Delivery Tailgate",
    "Delivery Weekend",
    "Delivery Notification",
    "Delivery Straight Truck",
    "Delivery Time Specific",
    "Delivery Date Time Specific",
    "Split Delivery",
    "Delivery Downtown",
    "Delivery Highcost Area",
    "Delivery Limited Access",
    "Delivery Attempted",
    "Delivery Advance Hours",
    "Delivery Certified",
    "Delivery Back Door"
];

export const PICKUP_TYPE: string[] = [
    "",
    "Pickup After Hours",
    "Pickup Extra",
    "Pickup Missed",
    "Pickup Tailgate",
    "Pickup Weekend",
    "Pickup Straight Truck",
    "Pickup Detention",
    "Pickup Origin",
    "Pickup Residential",
    "Pickup Single Shipment",
    "Pickup Rate",
    "Pickup Extra",
    "Pickup Inside",
    "Pickup Certified",
    "Pickup Time Specific",
    "Pickup Date Time Specific"
];

export const LABOURER_TYPE: string[] = [
    "",
    "Helper",
    "Helper Overtime",
    "Crew Leader",
    "Labour",
    "Warehouse Labour",
    "Lumper Handling",
    "Labour Mileage",
    "Driver Assist"
];

export const GENERAL_DOCUMENT = {
    '2'     :     'Bill of Lading or Manifest',
    '5'     :     'Carrier Confirmation',
    '6'     :     'Carrier Invoice',
    '8'     :     'Damage Claims',
    '18'    :    'Credit Card Receipt',
    '7'     :     'Customs Document',
    '3'     :     'Delivery Receipt (if addition to PoD)',
    '14'    :    'Email',
    '15'    :    'Lumper Receipt',
    '16'    :    'Marshalling',
    '9'     :     'Other Documents (Bond Receipt)',
    '10'    :    'Packing Slip',
    '17'    :    'Photos',
    '11'    :    'Pickup',
    '1'     :     'POD - Proof Of Delivery',
    '12'    :    'Scale Ticket',
    '4'     :     'Walk The Path - Delivery / Installation Document', 
    '13'    :    'Weight Inspection Certificate'

};

export const HOUSEHOLD_INTO_CAN = {
        '46'    :    'Passports',
        '47'    :    'Work Permit or Visa',
        '48'    :    'Inventory Listing of Household Goods',
        '49'    :    'New Canadian Address',
        '50'    :    'Scale Tickets on Full Loads'
}

export const HOUSEHOLD_INTO_US = {
    '39'    :    'Passports',
    '40'    :    'Form 3299 – Declaration for Free Entry',
    '41'    :    'Power of Attorney',
    '42'    :    'Supplemental Declaration',
    '43'    :    'Inventory Listing of Household Goods',
    '44'    :    'I-94 Card for Each Traveller',
    '45'    :    'Scale Tickets on Full Loads'
}